import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const AccountButtonIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });
  return (
    <Icon viewBox="0 0 24 24" {...rest} __css={styles}>
      <desc id="svgdescWLAccountButtonIcon">Account Button Icon</desc>
      <path d="M12,7.5c-2.1,0-3.6,1.8-3.6,4.3c0,2.5,1.5,4.3,3.6,4.3c2.1,0,3.6-1.8,3.6-4.3C15.6,9.3,14.1,7.5,12,7.5zM12,15.4c-1.6,0-2.8-1.5-2.8-3.5c0-2.1,1.2-3.5,2.8-3.5c1.6,0,2.8,1.5,2.8,3.5C14.8,13.9,13.6,15.4,12,15.4z" />
      <path d="M18.7,17.1c1.1-1.4,1.7-3.2,1.7-5.1c0-4.6-3.8-8.4-8.4-8.4S3.6,7.4,3.6,12c0,1.9,0.6,3.6,1.7,5.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c1.6,2.1,4,3.2,6.6,3.2C14.7,20.4,17,19.1,18.7,17.1C18.6,17.1,18.6,17.1,18.7,17.1C18.6,17.1,18.6,17.1,18.7,17.1z M12,19.6c-2.2,0-4.3-1-5.8-2.7c0.6-0.5,1.4-0.9,2.3-1.1c0.2-0.1,0.3-0.3,0.2-0.5c-0.1-0.2-0.3-0.3-0.5-0.2c-1,0.3-1.9,0.7-2.6,1.3c-0.9-1.3-1.4-2.8-1.4-4.4c0-4.2,3.4-7.6,7.6-7.6c4.2,0,7.6,3.4,7.6,7.6c0,1.6-0.5,3.1-1.4,4.4c-0.7-0.5-1.6-1-2.6-1.3c-0.2-0.1-0.4,0.1-0.5,0.3c-0.1,0.2,0.1,0.4,0.3,0.5c0.9,0.3,1.7,0.7,2.4,1.1C16.4,18.6,14.3,19.6,12,19.6z" />
    </Icon>
  );
};

export default AccountButtonIcon;
